import React from 'react';
import { motion } from 'framer-motion';
import { Building2Icon, ClipboardCheckIcon, HomeIcon, LampDeskIcon, MessagesSquareIcon, ScanLineIcon } from 'lucide-react';
const services = [[Building2Icon, 'Proyecto Arquitectónico', 'Ideas rigurosas que toman forma y perduran.'], [HomeIcon, 'Reformas y Ampliaciones', 'Nuevas posibilidades para espacios existentes.'], [LampDeskIcon, 'Diseño de Interiores', 'Materialidad, luz y detalles que se sienten propios.'], [ClipboardCheckIcon, 'Dirección de Obra', 'Acompañamiento preciso en cada decisión.'], [ScanLineIcon, 'Renders y Visualización 3D', 'Imágenes para imaginar antes de construir.'], [MessagesSquareIcon, 'Asesorías', 'Claridad para dar el primer paso con confianza.']];
export function AboutServices() {
  return <>
      <section id="sobre-mi" className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:grid-cols-2 md:items-center md:px-10 lg:gap-24 lg:py-36" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative" data-id="element-11">
          <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=1000&q=85" alt="Retrato de una arquitecta joven" className="h-[520px] w-full object-cover md:h-[640px]" data-id="element-12" />
          <div className="absolute -bottom-5 right-5 bg-[#F7F4EF] px-5 py-4 text-[10px] font-bold uppercase tracking-[.18em] md:-right-8" data-id="element-13">
            María Victoria Corbalan
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} data-id="element-14">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-15">
            Sobre mí
          </p>
          <h2 className="font-editorial mt-5 max-w-lg text-4xl leading-tight md:text-5xl" data-id="element-16">
            Arquitectura pensada desde las personas
          </h2>
          <p className="mt-6 max-w-lg text-sm leading-7 text-[#5e5a55]" data-id="element-17">
            Creo proyectos serenos, honestos y profundamente habitables. Cada
            decisión comienza escuchando: cómo vivís, qué necesitás y qué querés
            sentir al llegar a casa.
          </p>
          <blockquote className="font-editorial my-8 border-l-2 border-[#C4724A] pl-5 text-2xl italic leading-snug" data-id="element-18">
            “Cada espacio tiene una historia. Mi trabajo es ayudarte a
            contarla.”
          </blockquote>
          <a href="#contacto" className="text-xs font-bold uppercase tracking-wider underline decoration-[#C4724A] decoration-2 underline-offset-8" data-id="element-19">
            Conocé mi historia →
          </a>
          <div className="mt-12 grid grid-cols-2 gap-3 border-t border-[#d9d1c5] pt-6" data-id="element-20">
            {[['12+', 'años de experiencia'], ['80+', 'proyectos']].map(([number, label]) => <div key={label} data-id="element-21">
                <div className="font-editorial text-3xl" data-id="element-22">{number}</div>
                <div className="mt-1 text-[10px] uppercase tracking-wider text-[#69625a]" data-id="element-23">
                  {label}
                </div>
              </div>)}
          </div>
        </motion.div>
      </section>
      <section id="servicios" className="bg-white px-5 py-24 md:px-10 lg:py-32" data-id="element-24">
        <div className="mx-auto max-w-[1440px]" data-id="element-25">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-26">
            Lo que hago
          </p>
          <div className="mb-12 flex flex-col justify-between gap-5 md:flex-row md:items-end" data-id="element-27">
            <h2 className="font-editorial max-w-2xl text-4xl leading-tight md:text-5xl" data-id="element-28">
              Servicios diseñados para cada etapa de tu proyecto
            </h2>
            <p className="max-w-xs text-sm leading-6 text-[#6c665f]" data-id="element-29">
              Una mirada integral para transformar una idea en un espacio real.
            </p>
          </div>
          <div className="grid border-l border-t border-[#e5e0d9] sm:grid-cols-2 lg:grid-cols-3" data-id="element-30">
            {services.map(([Icon, title, description], i) => <motion.article initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} key={title} className="group relative min-h-[200px] border-b border-r border-[#e5e0d9] p-7" data-id="element-31">
                <div className="absolute left-0 top-0 h-1 w-0 bg-[#C4724A] transition-all duration-300 group-hover:w-full" data-id="element-32" />
                <Icon size={25} strokeWidth={1.25} data-id="element-33" />
                <h3 className="mt-10 text-sm font-bold" data-id="element-34">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-[#6c665f]" data-id="element-35">
                  {description}
                </p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}